import styled from 'styled-components';
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer } from 'react-toastify';

const NotificationStyled = styled(ToastContainer)`
  @media (min-width: 769px) {
    width: 380px;
  }

  .Toastify__toast {
    box-shadow: 0px 6px 12px rgba(56, 20, 81, 0.15);
    border-radius: 8px;
    background: #76489b;
    font-family: 'cerapro';
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;

    @media (min-width: 769px) {
      width: 360px;
    }
  }

  .Toastify__toast--success {
    box-shadow: 0px 6px 12px rgba(56, 20, 81, 0.15);
    border-radius: 8px;
    background: #e0f7f1;
    border: 2px solid #33cc9e
    font-family: 'cerapro';
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    color: #0e141d;
    padding: 18px 16px;
    width: 95%;
    margin: 20px auto;

    @media (min-width: 769px) {
      width: 100%;
      margin: 0px;
    }
  }

  .Toastify__toast--error {
    box-shadow: 0px 6px 12px rgba(56, 20, 81, 0.15);
    border: 2px solid #fd3a4a;
    border-radius: 8px;
    background: #ffe2e4;
    font-family: 'cerapro';
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: #0e141d;
    padding: 18px 16px;
    width: 95%;
    margin: 20px auto;

    @media (min-width: 769px) {
      width: 100%;
      margin: 0;
    }
  }

  .Toastify__close-button {
    opacity: 1;
    color: #ffffff;
  }

  .Toastify__toast--custom-clean {
    background-color: transparent;
    padding: 0;
    min-height: auto;
    .Toastify__close-button {
      display: none;
    }
  }
`;

export default NotificationStyled;
